import loadable from 'components/dynamic-import';
import { NotificationSkeletons } from 'components/component-skeletons';

export const Notifications = loadable(() => import('./Notifications'), true, <NotificationSkeletons />);
